import { Button } from "@/components/ui/button";

export const CursosFeatureSection = () => {
  return (
    <section className="rounded-3xl bg-card p-8 md:p-12">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">Por que se capacitar?</h2>
        <div className="space-y-4 text-muted-foreground mb-8">
          <p>
            O mercado imobiliário está em constante evolução. Profissionais que investem em
            conhecimento conquistam melhores oportunidades, fecham mais negócios e constroem
            uma reputação sólida no setor.
          </p>
          <p>
            Selecionamos criteriosamente cursos ministrados por especialistas
            com ampla experiência prática, garantindo que você aprenda o que realmente
            funciona no dia a dia do mercado imobiliário.
          </p>
        </div>
        <Button className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8">
          Ver Todos os Cursos
        </Button>
      </div>
    </section>
  );
};
